import { abbreviateVraagCode } from "./utils";

interface VraagLabelVraag {
  code: string;
  subvragen?: { letter: string }[] | null;
}

interface VraagLabelSubvraag {
  letter: string;
}

export function getOpgaveLabel(
  vraag: VraagLabelVraag | null | undefined,
  subvraag: VraagLabelSubvraag | null | undefined
) {
  if (!vraag || !subvraag) return undefined;
  const code = abbreviateVraagCode(vraag.code);
  const hasMultipleSubvragen = (vraag.subvragen?.length ?? 0) > 1;
  return hasMultipleSubvragen
    ? `${code}${subvraag.letter}`
    : `${code}`;
}
